import Phaser from 'phaser';
import { isMobile } from '../utils/platform';

// PLAYER_SCALE — БАЗОВАЯ визуальная пропорция игрока (компенсация muzzle-position
// для нижней зоны). Применяется ВСЕГДА. К ней дополнительно умножается getEntityScale
// (адаптация от высоты экрана), см. Player.ts.
// История: 0.5 → 0.425 (докрутка Волны 1, размер игрока −15% синхронно с врагами).
// Меняется автоматически: TORSO_*/HEAD_*/MUZZLE_* baked PLAYER_SCALE'ом, поэтому
// getPlayerMuzzleYOffsetFromCenter и PLAYER_TORSO_HALF_HEIGHT пересчитываются →
// инвариант достижимости getReachableSpawnYMax адаптируется без ручной правки.
export const PLAYER_SCALE = 0.425;

// Баланс-множитель скорости обычных врагов на мобильном. После adaptive entityScale
// поле визуально ужалось, но скорость в px/s осталась прежней → враги "носились"
// относительно компактного поля. 0.48 = −52%, темп комфортный для целения пальцем.
// Десктоп не трогаем (там поле полное, темп был ок). Применяется в behaviors
// (Chase/DriftingChase/Wolf/RandomZigzag), не касается боссов (отдельные boss-behaviors).
// История: 0.67 (Волна 1) → 0.57 (докрутка 1) → 0.48 (докрутка 2, ещё −15%).
const ENEMY_SPEED_MOBILE_MULTIPLIER = 0.48;

export function getEnemyMobileSpeedMultiplier(): number {
  return isMobile() ? ENEMY_SPEED_MOBILE_MULTIPLIER : 1.0;
}
// ENTITY_SCALE — резерв константного множителя для врагов. Не используется
// (адаптивный масштаб теперь через getEntityScale ниже).
export const ENTITY_SCALE = 1.0;

// Базовая высота сцены, при которой адаптивные масштабы = 1.0 (десктоп-эталон).
const BASE_HEIGHT = 720;

// UI-масштаб: HUD (слоты оружия, кнопка перезарядки, HP-иконки) и VirtualJoystick.
// На 720+ = 1.0 (десктоп идентичен прошлому). На 360 (mobile landscape) = 0.5 —
// HUD занимает примерно треть высоты вместо половины.
export function getUiScale(scene: Phaser.Scene): number {
  const ratio = scene.scale.height / BASE_HEIGHT;
  return Phaser.Math.Clamp(ratio, 0.5, 1.0);
}

// Entity-масштаб: игрок, враги, боссы. Чуть мягче UI (не уменьшаются настолько),
// чтобы враги/игрок оставались считываемыми на компактном экране.
// На 720+ = 1.0. На 360 = 0.55 — игрок и враги почти в два раза меньше.
export function getEntityScale(scene: Phaser.Scene): number {
  const ratio = scene.scale.height / BASE_HEIGHT;
  return Phaser.Math.Clamp(ratio, 0.55, 1.0);
}
